module.exports = __webpack_public_path__ + "static/power-img1-2-ebea1951a5729e5e7972c7f092a6007e.png";